import logoWPH from "../../assets/caresLogo.png";
import logoL365 from "../../assets/Life365.svg";
import logoGlobalMed from "../../assets/globalMed.svg";
import logoCTH from "../../assets/careTalkHealth.png";
import nox from "../../assets/JohnKnoxVillage.png";

export const getLogo = () => {
  let logo;
  switch (window.location.origin) {
    case "https://wph.prd.life365inc.com":
      logo = logoWPH;
      break;
    case "https://globalmed.prd.life365inc.com":
      logo = logoGlobalMed;
      break;
    case "https://l365.sbx.life365inc.com":
      logo = logoL365;
      break;
    case "https://care.prd.life365inc.com/":
      logo = logoCTH;
      break;
    default:
      logo = logoL365;
      break;
  }
  return logo;
};
